/**
 *
 *    GIFT CARD IN CART
 *    Contains all functions needed to add or remove a giftcard code to or from the cart
 *
 */

// Add giftcard code
function AddGiftCardCode() {

    // If enter in gift card code field
    $("input#txtGiftcardCode").keypress(function (e) {
        if (e.which == 13) {
            $(this).blur();
            return false
        }
    });

    // After entering a gift card code
    $("input#txtGiftcardCode").blur(function () {
        // Validate
        if ($(this).val() != "") {
            // Check if it's a valid gift card code and if valid, save the gift card code in session
            var strParams = "strAction=add&intAddressNo=" + intAddressNo + "&strGiftCardCode=" + $(this).val();
            $.post(strAjaxPath + "cart/giftcard.php", strParams, function (arrObjecten) {
                // Remove previous errors
                $("#gift-cart-error").remove();
                if (arrObjecten.value == 0) {
                    // Error
                    var objLi = $("<li id='gift-cart-error'></li>");
                    var objDivBoxInfo = $("<div class='alert error'></div>");
                    objDivBoxInfo.html("<p>" + html_entity_decode(arrObjecten.message) + "</p>");
                    objLi.append(objDivBoxInfo);
                    $("#gift-card-form").append(objLi);
                } else if (arrObjecten.value == 1) {
                    // Correct code => reload page
                    document.location.reload();
                }
            }, "json");
        }
    });

    // When clicking on button 'Add' (and not filled in the gift card code)
    $("#gift-card-form #btnAddGiftCard").click(function () {
        if ($("input#txtGiftcardCode").val() == "") {
            $("li#gift-cart-error").remove();

            if (typeof strLabelGiftCardNotValid !== 'undefined') {
                var objLi = $("<li id='gift-cart-error'></li>");
                var objDivBoxInfo = $("<div class='alert error'></div>");
                objDivBoxInfo.html("<p>" + strLabelGiftCardNotValid + "</p>");
                objLi.append(objDivBoxInfo);
                $("#gift-card-form").append(objLi);
            }
        }
    });
}

// Remove giftcard code
function RemoveGiftCardCode() {
    $("a.remove-giftcard").click(function () {
        var arrGiftcardno = $(this).attr("id").split("-")
        var strParams = "strAction=delete&intGiftCardNo=" + arrGiftcardno[2];
        $.post(strAjaxPath + "cart/giftcard.php", strParams, function (arrObjecten) {
            // Remove previous errors
            $("div#gift-card-error").remove();
            if (arrObjecten.value == 0) {
                // Error
                var objDivError = $("<div class='alert error' id='gift-card-error'></div>");
                objDivError.text(arrObjecten.message);
                $("div#giftcard-added table").after(objDivError);
            } else if (arrObjecten.value == 1) {
                // Right code => reload page
                document.location.reload();
            }
        }, "json");

        return false;
    });
}

window.RemoveGiftCardCode = RemoveGiftCardCode;
window.AddGiftCardCode = AddGiftCardCode;
